import { Button } from "@rai/ui/button";
import { BrandLogo } from "@rai/ui/brand/brand-logo";
import { siteConfig } from "@rai/core/lib/site";
import { Link } from "@/lib/navigation";

/** A portal address that doesn't exist, or a portal that's still hidden before launch. */
export function NotFound() {
  return (
    <main id="main-content" tabIndex={-1} className="page-container flex min-h-screen flex-col items-center justify-center bg-stone-50 py-20 text-center">
      <Link href="/" className="mb-10 inline-flex min-h-11 items-center" aria-label="Rai Computer home"><BrandLogo /></Link>
      <h1 className="text-2xl font-medium tracking-[-0.02em] text-stone-950">This page doesn&apos;t exist</h1>
      <p className="mt-2 text-sm text-stone-600">The link may have changed. Go back to {siteConfig.name}, or call us and we&apos;ll help directly.</p>
      <div className="mt-6 flex justify-center gap-2">
        <Button asChild><Link href="/">Go to the website</Link></Button>
        <Button asChild variant="outline"><a href={siteConfig.phone.href}>Call {siteConfig.phone.display}</a></Button>
      </div>
    </main>
  );
}
